import dayjs from "dayjs";
import type { FulfilmentSearchFilters } from "./fulfilmentSearchFiltersStoreSlice";

export const fulfilmentSearchFiltersDefaultValues: FulfilmentSearchFilters = {
    deadlineFrom: dayjs().subtract(1, "month").startOf("day").toDate(),
    deadlineTo: dayjs().add(1, "month").endOf("day").toDate(),
    statuses: [],
    withWarnings: false,
    fulfilmentName: undefined,
    taxPayerWorkspaceId: undefined,
    expired: undefined,
};
